import { styled } from '@mui/material/styles';
import React, { useContext } from 'react';

import IconRenderer from '../../ui/Icons/IconRenderer';
import { AppContext } from '../../capabilities/contextStore/AppContext';

import { generatePaymentMethodError } from './utils/generatePaymentMethodError';

const StyledAlert = styled('div')`
  ${({ theme }) => `& > .paymentMethodChip {
    display: flex;
    border-color: ${theme.palette.warning.main};
    border-width: 1px;
    gap: 5px;
    align-items: flex-start;
    border-radius: ${theme.shape.borderRadius}px;
    background-color: ${theme.palette.warning.light};
    text-align: left;
    padding-top: 2px;
    padding-left: 8px;
    padding-right: 8px;
    padding-bottom: 2px;
   
    & > .paymentMethodChipLabel {
      font-size: 12px;
      color: ${theme.palette.grey[700]};
      text-align: start;
      font-weight: bold;
    }  
  }
  `}
`;

const PaymentMethodWarning = () => {
  const { initialSessionData } = useContext(AppContext);
  const paymentMethodStatus = generatePaymentMethodError(
    initialSessionData,
  );
  return (
    <StyledAlert>
      {paymentMethodStatus.map(
        ({ text, iconName, chipType }, index) => {
          const idSuffix = chipType;

          return (
            <div
              className="paymentMethodChip"
              id={`paymentMethodTileChip-${idSuffix}`}
              data-testid={`paymentMethodTileChip-${idSuffix}`}
              key={index}
            >
              <div>
                <IconRenderer
                  name={iconName}
                  testId={`paymentMethodTileChipIcon-${idSuffix}`}
                  data-testid={`paymentMethodTileChipIcon-${idSuffix}`}
                  sx={{ width: '16px', height: '16px' }}
                />
              </div>
              <div
                className="paymentMethodChipLabel"
                id={`paymentMethodTileChipLabel-${idSuffix}`}
                data-testid={`paymentMethodTileChipLabel-${idSuffix}`}
              >
                {text}
              </div>
            </div>
          );
        },
      )}
    </StyledAlert>
  );
};

export default PaymentMethodWarning;
